// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  matchId: __t.string().name("match_id"),
  unitAId: __t.string().name("unit_a_id"),
  unitBId: __t.string().name("unit_b_id"),
  tickStarted: __t.u32().name("tick_started"),
  tickEnded: __t.u32().name("tick_ended"),
  naturalDisengageCounter: __t.u32().name("natural_disengage_counter"),
  chargeAppliedA: __t.bool().name("charge_applied_a"),
  chargeAppliedB: __t.bool().name("charge_applied_b"),
  ticksActive: __t.u32().name("ticks_active"),
  outcome: __t.string(),
  directionOnA: __t.string().name("direction_on_a"),
  directionOnB: __t.string().name("direction_on_b"),
  totalDamageAToB: __t.f64().name("total_damage_a_to_b"),
  totalDamageBToA: __t.f64().name("total_damage_b_to_a"),
  totalMoraleAToB: __t.f64().name("total_morale_a_to_b"),
  totalMoraleBToA: __t.f64().name("total_morale_b_to_a"),
  frontLocked: __t.bool().name("front_locked"),
  recentDamageAToB: __t.array(__t.f64()).name("recent_damage_a_to_b"),
  recentDamageBToA: __t.array(__t.f64()).name("recent_damage_b_to_a"),
  chargeContactJson: __t.option(__t.string()).name("charge_contact_json"),
});
